import {
  inventory_details_overall,
  inventory_details_area,
  inventory_details_cluster,
  inventory_details_branch,
  inventory_details_branch_concurrent_request,
} from "../../services/reports/inventory_details_service";
import { actionTypes } from "../action_types";

const default_data = {
  branchCount: 0,
  totalPiecesDetails: {
    active: 0,
    expired: 0,
    expiredPercentage: 0,
  },
  totalPrincipalDetails: {
    active: 0,
    expired: 0,
    expiredPercentage: 0,
  },
  totalPieces: 0,
  totalPrincipal: 0,
  averagePrincipalPerPiece: 0,
};

const createInventoryDetailsAction =
  (fetchFunction, actionType) => (data) => (dispatch) => {
    return fetchFunction(data).then((resp) => {
      if (resp.problem === null) {
        dispatch({
          type: actionType,
          payload: resp.data !== null ? resp.data : default_data,
        });
      }
      return Promise.resolve(resp);
    });
  };

export const GetInventoryDetailsOverall = createInventoryDetailsAction(
  inventory_details_overall,
  actionTypes.REPORTS_INVENTORY_DETAILS_GET_OVERALL
);

export const GetInventoryDetailsCluster = createInventoryDetailsAction(
  inventory_details_cluster,
  actionTypes.REPORTS_INVENTORY_DETAILS_GET_CLUSTER
);

export const GetInventoryDetailsArea = createInventoryDetailsAction(
  inventory_details_area,
  actionTypes.REPORTS_INVENTORY_DETAILS_TARGET_GET_AREA
);

export const GetInventoryDetailsBranch = createInventoryDetailsAction(
  inventory_details_branch,
  actionTypes.REPORTS_INVENTORY_DETAILS_TARGET_GET_BRANCH
);

export const GetInventoryDetailsBranchConcurrentRequest =
  createInventoryDetailsAction(
    inventory_details_branch_concurrent_request,
    actionTypes.REPORTS_INVENTORY_DETAILS_TARGET_GET_BRANCH
  );
